import { Expose, Transform } from 'class-transformer';
import { TEXTFIELD_BUTTON_ACTION_TYPES } from '@/models/enums/textfield-button-action-types.enum';
import cuid from 'cuid';

export class TextFieldProps {
  @Expose()
  label!: string;

  @Expose()
  id!: string;

  @Expose()
  title!: string;

  @Expose()
  value!: string;

  @Expose({ name: 'elementType' })
  @Transform(({ value }) => `${value || 'field'}${cuid()}`)
  name!: string;

  @Expose()
  type!: string;

  @Expose()
  actionButton!: {
    actions: TEXTFIELD_BUTTON_ACTION_TYPES;
    text: string;
  };

  @Expose()
  externalApiIdentifier!: string | null;
}
